import { utl_parseData, html } from "../base/_utils";
import Papa from "papaparse";

async function getAndDisplayData() {
    const collegiateTwirlingData =
        "https://docs.google.com/spreadsheets/d/e/2PACX-1vQlThNVSp1zukIrwKllbophSol64UiYfDTBWU_nMrxQAXQPYGKLlp2_Kw79dzEWyRx7jo9Wnn7YN81u/pub?gid=877154685&single=true&output=csv";

    try {
        // Fetch and parse the data
        const results = await utl_parseData(collegiateTwirlingData, Papa);
        let data = results.data;

        // Display the data
        for (let i = 0; i < data.length; i++) {
            document.getElementById("collegiate-twirling-and-tryouts-state-quicklinks-list").innerHTML += html`
                <td>${data[i].varUniversity}</td>
                <td>${data[i].varLocation}</td>
                <td><a href="${data[i].varLink}" target="_blank">Visit Website for More Information</a></td>
            `;
        }
    } catch (error) {
        // Handle errors
        console.error("Error parsing data:", error);
    }
}

getAndDisplayData();
